import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../ui/Modal';

interface ConfirmDeleteShipmentModalProps {
  shipmentName: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const ConfirmDeleteShipmentModal: React.FC<ConfirmDeleteShipmentModalProps> = ({
  shipmentName,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen onClose={onCancel} title={t('shipment_delete_modal_title')} hideCloseButton isCentered>
      <p>{t('shipment_delete_modal_body', { name: shipmentName })}</p>
      <div className="modal-buttons">
        <button className="modal-button cancel-delete" onClick={onCancel} disabled={loading}>
          {t('cancel')}
        </button>
        <button className="modal-button confirm-delete" onClick={onConfirm} disabled={loading}>
          {t('shipment_delete_modal_confirm')}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteShipmentModal;
